import React from 'react';
import { Card, Panel } from 'framework-ui-components';
import PageWrapperV2 from './PageWrapperV2';
import FiltriRicerca from './FiltriRicerca';
import ElencoDichiarazioni from './ElencoDichiarazioni';
import BarraAzioni from './BarraAzioni';

export default (params) => (
  <PageWrapperV2
    helmetTitle="Assegno nucleo familiare"
    pageTitle="ANF"
    {...params}  >
    {
      params.accessoNonConsentito ? (
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            <Grid.Col md="12">
              <div className="errorBoundary">
                <div className="errorBoundary__content">
                  <Badge alarm><ErroreIcon /></Badge>
                  <h2>Il servizio Assegni Nucleo Familiare non è attivo</h2>
                </div>
              </div>
            </Grid.Col>
          </Grid.Row>
        </Grid>

      ) : (
        <Card title="Lista domande">
          {
            !params.servizioAttivo
            && !params.accessoNonConsentito
            && <Panel error>Il servizio non è attivo. L&quot;accesso è permesso solo in consultazione</Panel>
            }
            <BarraAzioni
              avviaCreazioneDichiarazioneOrdinaria
              avviaCreazioneDichiarazioneVariazione
              avviaCreazioneDichiarazioneArretrata
              dichiarazioniSelezionate
              {...params} />
          <FiltriRicerca {...params} />
          <ElencoDichiarazioni {...params} />
        </Card>
      )
    }
  </PageWrapperV2>
);
